<app-table [actionColumnWidth]="400" [columns]="columns" [loading]="loading" [value]="users" filename="MENU.USERS">
  <ng-template (onClick)="createUser()" appToolbarButton icon="fal fa-plus" labelKey="USERS.CREATE_USER"></ng-template>

  @if (isRodixAdmin()) {
    <ng-template
      (onClick)="impersonate($event.row)"
      appActionButton
      icon="fal fa-people-arrows"
      labelKey="USERS.IMPERSONATE"
      type="warning"></ng-template>
  }

  <ng-template
    (onClick)="deleteUser($event.row)"
    appActionButton
    icon="fal fa-trash"
    labelKey="USERS.DELETE_HEADER"
    type="danger"></ng-template>
</app-table>
